import type { AppUser, Aprovacao } from '../types'
import { isPerfilDiretivo } from './accessControl'

export function isAprovacaoVisivelParaUsuario(aprovacao: Aprovacao, user: AppUser | null | undefined) {
  if (isPerfilDiretivo(user?.perfil)) return true
  if (!user) return false
  if (aprovacao.solicitante_usuario_id) return aprovacao.solicitante_usuario_id === user.id
  if (aprovacao.solicitante_perfil) return aprovacao.solicitante_perfil === user.perfil
  return aprovacao.etapa_aprovacao === user.perfil || aprovacao.perfil_aprovador === user.perfil
}

export function filtrarAprovacoesVisiveis(aprovacoes: Aprovacao[], user: AppUser | null | undefined) {
  return aprovacoes.filter(aprovacao => isAprovacaoVisivelParaUsuario(aprovacao, user))
}

export function countAprovacoesPendentesVisiveis(aprovacoes: Aprovacao[], user: AppUser | null | undefined) {
  return filtrarAprovacoesVisiveis(aprovacoes, user).filter(aprovacao => aprovacao.status === 'PENDENTE').length
}
